import React from 'react'
import clsx from 'clsx'

import { useSettingsPageStyles } from '../../hooks/settingsPageStylesHook'

import { Box, FormHelperText, FormLabel, Grid } from '@material-ui/core'

import { IOSSwitch } from '../IOSSwitch'

export type RealizationReportsSwitchProps = {
  value: boolean

  onToggle: VoidFunction
}

export const RealizationReportsSwitch =
  ({value, onToggle}: RealizationReportsSwitchProps) => {
    const classes = useSettingsPageStyles()

    return (
      <Grid item xs={9}>
        <Grid container className={clsx(classes.settingsTopic, 'default-border')}>
          <Grid item className={classes.root} xs={12}>
            <Box width={'100%'} display="flex" justifyContent="space-between" alignItems="center">
              <Box>
                <FormLabel className={classes.unifiedPricesLabel}>
                  Синхронизация отчётов о реализации
                </FormLabel>

                <FormHelperText className={classes.helperText}>
                  Создание отчёта комиссионера в МоёмСкладе. В него будут добавляться только товары, для которых
                  включена синхронизация.
                </FormHelperText>
              </Box>

              <IOSSwitch checked={value} onChange={onToggle}/>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    )
  }